import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import appSelectors from 'redux/app/appSelectors';

import { setDisplayMenu, setLanguage, setTheme } from 'redux/app/appSlice';

import useMatchMedia from 'hooks/useMatchMedia';

import CloseIcon from 'images/close.svg?react';
import MoonIcon from 'images/header/moon.svg?react';
import SunIcon from 'images/header/sun.svg?react';

import Portal from 'ui/portal';
import Logo from 'components/logo';

import BtnProfile from '../btnProfile';
import Nav from '../nav';
import BtnLogout from '../btnLogout';

import s from './menu.module.css';

function Menu() {
  const dispatch = useDispatch();
  const lang = useSelector(appSelectors.language);
  const theme = useSelector(appSelectors.theme);
  const i18n = useSelector(appSelectors.translation);

  const { isMobile } = useMatchMedia();

  const [opened, setOpened] = useState(false);

  const close = () => dispatch(setDisplayMenu(false));

  const handleClick = () => {
    setOpened(false);

    const delayedAction = setTimeout(() => {
      close();
      clearTimeout(delayedAction);
    }, 300);
  };

  const toggleLang = () => {
    const nextLang = lang === 'ru' ? 'en' : 'ru';
    dispatch(setLanguage(nextLang));
    localStorage.setItem('vps24-language', nextLang);
  };

  const toggleTheme = () => {
    const nextTheme = theme === 'dark' ? 'light' : 'dark';
    dispatch(setTheme(nextTheme));
    localStorage.setItem('vps24-theme', theme);
  };

  useEffect(() => {
    setOpened(true);
  }, []);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  const backdropStyles = opened ? s.backdrop_active : s.backdrop;
  const menuStyles = opened ? s.menu_active : s.menu;

  return (
    <Portal>
      <div className={backdropStyles} onClick={handleClick}>
        <div className={menuStyles}>
          <div className={s.wrapper}>
            <Logo />
            <div className={s.btns_wrapper}>
              {isMobile && <BtnProfile />}
              <button
                type="button"
                onClick={handleClick}
                className={s.btn_close}
              >
                <CloseIcon />
              </button>
            </div>
          </div>

          <Nav />

          {isMobile && (
            <button
              type="button"
              onClick={toggleTheme}
              className={s.btn_theme}
              title="theme"
            >
              {theme === 'dark' ? <SunIcon /> : <MoonIcon />} {i18n.Тема}
            </button>
          )}

          {isMobile && (
            <button
              type="button"
              onClick={toggleLang}
              className={s.btn_lang}
              title="language"
            >
              <span>{lang.toUpperCase()}</span> {i18n.Язык}
            </button>
          )}

          <BtnLogout />
        </div>
      </div>
    </Portal>
  );
}

export default Menu;
